import { ErrorState } from "@packages/core-client/errors/ErrorState.tsx";
import { ErrorStateBackLink } from "@packages/core-client/errors/ErrorStateBackLink.tsx";
import { useI18nextInstance } from "@squide/i18next";
import { useTranslation } from "react-i18next";
import { i18NextInstanceKey } from "../../../i18n/i18next.ts";

export function ProfileNotFound() {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation("ProfileNotFound", { i18n: i18nextInstance });

    return <ErrorState kind="notFound" ownsPageTitle title={t("heading")} description={t("body")} action={<ErrorStateBackLink href="/people">{t("backToDirectory")}</ErrorStateBackLink>} />;
}
